import { Cloud, CloudCheck, CloudOff, RefreshCw } from 'lucide-react';
import { applyRemoteUserData, retryUserDataSync, useUserDataSync } from './userDataSync';

export function SyncAccountStatus() {
  const sync = useUserDataSync();
  return <p className="text-[10px] text-muted-foreground mt-1" role="status">
    {sync.error ? `${sync.pending} 项待上传，联网后重试` : sync.pending || sync.syncing ? '正在同步账号数据…' : '测评、训练、饮食与打卡已同步到云端'}
  </p>;
}
export default function SyncFeedback() {
  const sync = useUserDataSync();
  if (!sync.remote && !sync.error && !sync.pending) return null;
  const Icon = sync.error ? CloudOff : sync.remote ? CloudCheck : Cloud;
  const text = sync.remote ? '其他设备有更新，点击载入' : sync.error ? sync.error : `${sync.pending} 项记录正在同步…`;
  return <div className="fixed left-1/2 -translate-x-1/2 bottom-[88px] z-[70] w-[calc(100%-32px)] max-w-[388px]" role="status" aria-live="polite">
    <button type="button" onClick={sync.remote ? applyRemoteUserData : retryUserDataSync}
      className="w-full metallic-card rounded-xl px-3 py-2 flex items-center gap-2 text-[11px] text-foreground shadow-lg text-left">
      <Icon className="w-4 h-4 shrink-0 text-primary" />
      <span className="flex-1">{text}</span>
      {(sync.error || sync.remote) && <RefreshCw className="w-3.5 h-3.5 shrink-0" />}
    </button>
    {sync.error && <button className="block ml-auto mt-1 text-[11px] text-primary px-3 py-1 rounded-lg bg-background" onClick={() => {
      void import('@/lib/data-manager').then(module => module.downloadBackup());
    }}>下载本机备份</button>}
  </div>;
}
